(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-article-grid"] && !Shopify.designMode) return;
  try {
    
  const blogArticleSections = document.querySelectorAll('[data-dm-blog-articles]');

  blogArticleSections.forEach((section) => {
    const grid = section.querySelector('[data-article-grid]');
    const tabs = section.querySelectorAll('[data-filter]');
    const emptyState = section.querySelector('[data-empty-state]');
    const pagination = section.querySelector('[data-articles-pagination]');
    const heading = section.querySelector('[data-articles-heading]');
    const copy = section.querySelector('[data-articles-copy]');
    const configElement = section.querySelector('[data-blog-articles-config]');
    const allowedFilters = ['all', 'real-stories', 'news', 'events', 'animal-welfare'];
    const paginationBreakpoint = window.matchMedia('(max-width: 749px)');
    let currentFilter = 'all';
    let currentPage = 1;
    let contentConfig = {};

    if (!grid) return;

    if (configElement) {
      try {
        contentConfig = JSON.parse(configElement.textContent || '{}');
      } catch (error) {
        contentConfig = {};
      }
    }

    Array.from(grid.children)
      .sort((a, b) => Number(b.dataset.date || 0) - Number(a.dataset.date || 0))
      .forEach((card) => grid.appendChild(card));

    const normalizeCategory = (value) => String(value || '').trim().toLowerCase();

    const getSafeFilter = (filter) => {
      const normalized = normalizeCategory(filter);
      return allowedFilters.includes(normalized) ? normalized : 'all';
    };

    const updateTabState = (filter) => {
      tabs.forEach((item) => {
        const isActive = getSafeFilter(item.dataset.filter) === filter;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });
    };

    const updateHeaderContent = (filter) => {
      const categoryContent = contentConfig[filter] || contentConfig.all || {};

      if (heading && categoryContent.heading) {
        heading.textContent = categoryContent.heading;
      }

      if (copy && categoryContent.copy) {
        copy.innerHTML = categoryContent.copy;
      }

      section.querySelector('.dm-blog-articles__header')?.style.setProperty('--dm-blog-heading-size', `${categoryContent.headingSize || 48}px`);
      section.querySelector('.dm-blog-articles__header')?.style.setProperty('--dm-blog-heading-width', `${categoryContent.headingMaxWidth || 760}px`);
      section.querySelector('.dm-blog-articles__header')?.style.setProperty('--dm-blog-copy-size', `${categoryContent.copySize || 16}px`);
      section.querySelector('.dm-blog-articles__header')?.style.setProperty('--dm-blog-copy-width', `${categoryContent.copyMaxWidth || 680}px`);
    };

    const scrollToGridTop = () => {
      const target = section.querySelector('[data-article-grid]');

      if (!target) return;

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const renderPagination = (totalCards) => {
      if (!pagination) return;

      const cardsPerPage = paginationBreakpoint.matches ? 4 : 6;
      const totalPages = Math.ceil(totalCards / cardsPerPage);
      pagination.innerHTML = '';
      pagination.hidden = totalPages <= 1;

      if (totalPages <= 1) return;

      const createButton = (label, page, options = {}) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `dm-blog-articles__page${options.control ? ' dm-blog-articles__page--control' : ''}${options.active ? ' is-active' : ''}`;
        if (options.icon === 'previous') {
          button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 6 9 12l6 6" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
          button.setAttribute('aria-label', 'Previous page');
        } else if (options.icon === 'next') {
          button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
          button.setAttribute('aria-label', 'Next page');
        } else {
          button.textContent = label;
          button.setAttribute('aria-label', `Page ${label}`);
        }
        button.disabled = Boolean(options.disabled);

        if (options.active) {
          button.setAttribute('aria-current', 'page');
        }

        button.addEventListener('click', () => {
          if (button.disabled || page === currentPage) return;
          currentPage = page;
          applyFilter(currentFilter, { preservePage: true, scroll: true });
        });

        return button;
      };

      const getVisiblePages = () => {
        const maxVisiblePages = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        startPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);
      };

      pagination.appendChild(createButton('', Math.max(1, currentPage - 1), {
        control: true,
        icon: 'previous',
        disabled: currentPage === 1
      }));

      getVisiblePages().forEach((page) => {
        pagination.appendChild(createButton(String(page), page, {
          active: page === currentPage
        }));
      });

      pagination.appendChild(createButton('', Math.min(totalPages, currentPage + 1), {
        control: true,
        icon: 'next',
        disabled: currentPage === totalPages
      }));
    };

    const applyFilter = (filter, options = {}) => {
      const activeFilter = getSafeFilter(filter);
      currentFilter = activeFilter;

      if (!options.preservePage) {
        currentPage = 1;
      }

      const matchingCards = [];
      let visibleCount = 0;

      grid.querySelectorAll('[data-category]').forEach((card) => {
        const cardCategory = normalizeCategory(card.dataset.category);
        const isMatch = activeFilter === 'all' || cardCategory === activeFilter;

        if (isMatch) {
          matchingCards.push(card);
        }

        card.hidden = true;
        card.style.display = 'none';
      });

      const cardsPerPage = paginationBreakpoint.matches ? 4 : 6;
      const totalPages = Math.max(1, Math.ceil(matchingCards.length / cardsPerPage));
      currentPage = Math.min(Math.max(1, currentPage), totalPages);

      matchingCards.forEach((card, index) => {
        const startsAt = (currentPage - 1) * cardsPerPage;
        const endsAt = startsAt + cardsPerPage;
        const isVisible = index >= startsAt && index < endsAt;
        card.hidden = !isVisible;
        card.style.display = isVisible ? '' : 'none';
        if (isVisible) visibleCount += 1;
      });

      renderPagination(matchingCards.length);
      updateHeaderContent(activeFilter);
      updateTabState(activeFilter);

      if (emptyState) emptyState.hidden = visibleCount !== 0;

      if (options.scroll) {
        scrollToGridTop();
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        applyFilter(tab.dataset.filter || 'all');
      });
    });

    const handlePaginationBreakpointChange = () => {
      applyFilter(currentFilter, { preservePage: true });
    };

    if (paginationBreakpoint.addEventListener) {
      paginationBreakpoint.addEventListener('change', handlePaginationBreakpointChange);
    } else {
      paginationBreakpoint.addListener(handlePaginationBreakpointChange);
    }

    const initialCategory = new URLSearchParams(window.location.search).get('category');
    applyFilter(initialCategory || 'all');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dairymind-faq-category"] && !Shopify.designMode) return;
  try {
    
  if (!window.DairyMindFaqV2) {
    window.DairyMindFaqV2 = true;
    document.addEventListener('click', function(event) {
      var button = event.target.closest('.dm-faq-v2-question');
      if (!button) return;
      var item = button.closest('.dm-faq-v2-item');
      var answer = document.getElementById(button.getAttribute('aria-controls'));
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      item.classList.toggle('is-open', !isOpen);
      answer.hidden = isOpen;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dairymind-lead-form-modal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.dairyMindLeadFormModalReady) return;
    window.dairyMindLeadFormModalReady = true;

    function modal() {
      return document.querySelector('[data-dairymind-lead-form-modal]');
    }

    function hasLeadFormSlot() {
      const leadModal = modal();
      const slot = leadModal?.querySelector('[data-dairymind-lead-form-slot]');
      return Boolean(slot && !slot.querySelector('.dm-lead-form-modal__empty'));
    }

    function openModal() {
      const leadModal = modal();
      if (!leadModal || !hasLeadFormSlot()) return false;
      if (typeof leadModal.showModal === 'function') {
        if (!leadModal.open) leadModal.showModal();
      } else {
        leadModal.setAttribute('open', '');
      }
      document.body.classList.add('dm-lead-form-modal-open');
      return true;
    }

    function closeModal() {
      const leadModal = modal();
      if (!leadModal) return;
      if (typeof leadModal.close === 'function' && leadModal.open) {
        leadModal.close();
      } else {
        leadModal.removeAttribute('open');
      }
      document.body.classList.remove('dm-lead-form-modal-open');
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-dairymind-lead-form-trigger]');
      if (trigger) {
        if (!openModal()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (event.target.matches('[data-dairymind-lead-form-close]') || event.target.closest('[data-dairymind-lead-form-close]')) {
        closeModal();
      }
    }, true);

    document.addEventListener('click', (event) => {
      const leadModal = modal();
      if (leadModal && event.target === leadModal) closeModal();
    });

    document.addEventListener('close', (event) => {
      if (event.target.matches('[data-dairymind-lead-form-modal]')) {
        document.body.classList.remove('dm-lead-form-modal-open');
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dairymind-warranty-policy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeWarrantyTabs = (root) => {
      if (!root || root.dataset.warrantyTabsReady === 'true') return;
      const navigation = root.querySelector('.dm-warranty__nav');
      const panels = Array.from(root.querySelectorAll('[data-policy-panel]'));
      const tabs = panels.map((panel, index) => {
        const tab = document.createElement('button');
        tab.id = `dm-warranty-tab-${panel.dataset.policyPanel}`;
        tab.className = `dm-warranty__tab${index === 0 ? ' is-active' : ''}`;
        tab.type = 'button';
        tab.setAttribute('role', 'tab');
        tab.dataset.policyTab = panel.dataset.policyPanel;
        tab.setAttribute('aria-controls', panel.id);
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.tabIndex = index === 0 ? 0 : -1;
        tab.innerHTML = '<span></span><svg class="dm-warranty__chevron" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="m7 4 5 5-5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>';
        tab.querySelector('span').textContent = panel.dataset.policyLabel || '';
        panel.setAttribute('aria-labelledby', tab.id);
        navigation.appendChild(tab);
        return tab;
      });

      const activate = (id, focusTab) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.policyTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focusTab) tab.focus();
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.policyPanel !== id;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.policyTab, false));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex !== index && ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            activate(tabs[nextIndex].dataset.policyTab, true);
          }
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate(tab.dataset.policyTab, true);
          }
        });
      });

      root.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest?.('[data-policy-panel]');
        if (panel) activate(panel.dataset.policyPanel, false);
      });

      if (tabs.length > 0) activate(tabs[0].dataset.policyTab, false);
      root.dataset.warrantyTabsReady = 'true';
    };

    const initializeAllWarrantyTabs = () => document.querySelectorAll('.dm-warranty').forEach(initializeWarrantyTabs);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAllWarrantyTabs);
    else initializeAllWarrantyTabs();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches?.('.dm-warranty') ? event.target : event.target.querySelector?.('.dm-warranty');
      initializeWarrantyTabs(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
